// extracted by mini-css-extract-plugin
module.exports = {"OSDToolbar":"bwn","PDFToolbar":"bwo","icon":"bwp","active":"bwq","withSpacer":"bwr","roundedUp":"bws","withBadge":"bwt"};